import { render, staticRenderFns } from "./mb-product-pile.vue?vue&type=template&id=42bcc684&"
import script from "./mb-product-pile.vue?vue&type=script&lang=js&"
export * from "./mb-product-pile.vue?vue&type=script&lang=js&"
import style0 from "./mb-product-pile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports